// extracted by mini-css-extract-plugin
module.exports = {"screenshot":"Screenshots-module--screenshot--TLEPH"};